import * as actionTypes from "../../actions/actionTypes";

const initialState = {
  curDr: {},
  curLocation: {},
};

const changeLocation = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DOCTOR:
      return {
        ...state,
        curDr: { ...action.payload[0] },
      };

    case actionTypes.CHANGE_CURRENT_LOCATION:
      return {
        ...state,
        curDr: {
          ...state.curDr,
          is_current_location: !state.curDr.is_current_location,
        },
      };

    case actionTypes.GET_CURRENT_LOCATION:
      return {
        ...state,
        curLocation: { ...action.payload[0] },
      };

    default:
      return state;
  }
};

export default changeLocation;
